
import CoreModule from './core'
import GridModule from './grid'
import IconsModule from './icons'
import GlobalModule from './global'
import AppModule from './modules/apps'
import SettingsModule from './modules/settings'
import ChecklistModule from './modules/checklist'

export default {
  ...CoreModule,
  ...AppModule,
  ...GridModule,
  ...IconsModule,
  ...GlobalModule,
  ...SettingsModule,
  ...ChecklistModule
}
